export const moduleNamespace = 'merchantCentreSetupWizard';

/**
 * Action constants
 */
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const SET_WHITELABEL_STATUS = 'SET_WHITELABEL_STATUS';
export const SET_WHITELABEL_CUSTOM_DOMAIN_MESSAGE = 'SET_WHITELABEL_CUSTOM_DOMAIN_MESSAGE';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_INCOMPLETE_CONFIGURATION = 'SET_INCOMPLETE_CONFIGURATION';
export const SET_REGISTRATION_FIELD = 'SET_REGISTRATION_FIELD';
export const SET_WHITELABEL_LOGO = 'SET_WHITELABEL_LOGO';
export const TOGGLE_TAX = 'TOGGLE_TAX';
export const UPDATE_TAX_RATE_PERCENTAGE = 'UPDATE_TAX_RATE_PERCENTAGE';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const UPDATE_COUNTRIES = 'UPDATE_COUNTRIES';
export const SET_FORM_FIELD = 'SET_FORM_FIELD';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_STRIPE_ACCOUNT_ERROR = 'SET_STRIPE_ACCOUNT_ERROR';

/**
 * Setup wizard available steps, sequenced in the order of process and display.
 */
export const STEPS = [
  'CUSTOM_DOMAIN',
  'CUSTOM_DOMAIN_SETUP',
  'CUSTOM_EMAIL',
  'CUSTOM_EMAIL_SETUP',
  'STRIPE_ACCOUNT',
  'TAX',
  'PRODUCTS',
  'ADDONS',
  'REGISTRATION',
  'READY_TO_GO',
];
